export const SET_CUSTOMER_SERVICE = 'SET_CUSTOMER_SERVICE'
// 直播相关
let liveInfo = {
  state: {
    liveToken: null, //cpp接口访问token
    liveId: null,
    assistantStatus: false,
    liveRoomStatus: 1, // 0  未开始  1; // 准备中  2; // 直播中  3; // 已过期
    pushStreamStatus: 1,
    recordStatus: 1, //是否是录制中的状态 0是 1否 3暂停
    flowStatus: true, //是否有正在推流的推流地址
    liveRoomType: 0, // 直播间类型 0 = 标准直播 1 = 虚拟直播
    liveConfig: {},
    controlLiveConfig: {
      control_live_SendAndView_chat: null,
      control_live_StartAndStop: null,
      control_live_announcement: null,
      control_live_answer: null,
      control_live_chat: null,
      control_live_check_in: null,
      control_live_layout: null,
      control_live_lottery: null,
      control_live_online_number_rules: null,
      control_live_push_stream: null,
      control_live_questionnaire: true,
      control_live_record: true,
      control_live_user_management: true,
      control_live_video_surveillance: true,
      control_live_voice_calls: true,
      control_live_commodity: null,
      control_live_rtmp_stream: false,
    }, //直播详情改变权限
    liveCid: null,
    liveTitle: '',
    liveLogo: '',
    userRole: '', //用户角色
    liveStartTime: '', // 直播场次开启时间
    playerUrl: '',
    voipInfo: null,
    isVoipName: undefined,
    all_user_online_count: 0,
    shareInfo: null,
    meetStatus: 0,
    guestSeeAuth: 2, //嘉宾是否显示列表 2：不显示 1：显示
    rewardCount: 0, //打赏
    praiseCount: 0, //礼物
    liveTime: null, //直播时长
    thirdPushStreamStatus: false, //是否存在第三方拉流
    autoRecording: 1, //是否开启了自动录制  1-打开 2关闭
    audit: null,
    opType: null, //opType:0 真直播   opType：3 伪直播    opType:2 第三方拉流
    streamStatus: null, // 1:结束  0：开始 2：有流
    used: null, //是否使用0,1
    tophighlight: null,
    pseudoLiveInfo: null,
    authCheckToken:"",
    confId: null, // 场次id
    userNumber:0,//观众数量
    is_customer_service:false,
    medaiStatus:-1,    // 播放状态，0表示准备中，还在下载中，1表示准备好了可以播放，2表示播放，3表示暂停，4表示停止，5表示异常
    hostUsersDuration:false,
    chatImages: false, // 聊天图片
    micDefault: 1,
    qaEnabled: false, //是否开启问答
    recordStartTime:'' , //录制开始时间
    cameraResolution:null, //摄像头分辨率
    videoWall:false,//是否显示视频墙
    hostSkin:"0",//皮肤  0->蓝
    audience: [],
    audioAudit: false,
    defaultSource: 0 //默认视频源，主播源
  },
  mutations: {
    SET_AUDIO_AUDIT(state, data) {
      state.audioAudit = data;
    },
    SET_LIVETOKEN(state, data) {
      state.liveToken = data;
    },
    SET_AUDIENCE(state, data) {
      state.audience = data;
    },
    SET_CONF_ID(state, data) {
      state.confId = data;
    },
    SET_LIVEID(state, data) {
      state.liveId = data;
    },
    SET_MEETSTATUS(state, data) {
      state.meetStatus = data;
    },
    SET_AUTHCHECKTOKEN(state, data){
      state.authCheckToken = data;
    },
    SET_SHAREINFO(state, data) {
      state.shareInfo = data;
    },
    SET_ASSISTANTSTATUS(state, data) {
      state.assistantStatus = data;
    },
    SET_LIVEROOMSTATUS(state, data) {
      state.liveRoomStatus = data;
    },
    SET_RECORDSTATUS(state, data) {
      state.recordStatus = data;
    },
    SET_PUSHSTREAMSTATUS(state, data) {
      state.pushStreamStatus = data;
    },
    SET_LIVECONFIG(state, data) {
      state.liveConfig = data;
    },
    SET_DEFAULT_SOURCE(state, data) {
      state.defaultSource = data;
    },
    SET_LIVEROOMTYPE(state, data) {
      state.liveRoomType = data;
    },
    SET_CONTROLLIVECONFIG(state, data) {
      state.controlLiveConfig = data;
    },
    SET_LIVECID(state, data) {
      state.liveCid = data;
    },
    SET_LIVETITLE(state, data) {
      state.liveTitle = data;
    },
    SET_LIVELOGO(state, data) {
      state.liveLogo = data;
    },
    SET_USERROLE(state, data) {
      state.userRole = data;
    },
    SET_LIVESTARTTIME(state, data) {
      state.liveStartTime = data;
    },
    SET_PLAYERURL(state, data) {
      state.playerUrl = data;
    },
    SET_FLOWSTATUS(state, data) {
      state.flowStatus = data;
    },
    SET_VOIPINFO(state, data) {
      state.voipInfo = data;
      if (data.voip) {
        state.isVoipName = data.voip.name
      }
    },
    SET_VOIP_INFO_NAME(state, data) {
      state.isVoipName = data;
    },
    SET_ONLINEUSERNUMBER(state, data) {
      state.all_user_online_count = data;
    },
    SET_GUESTSEEAUTH(state, data) {
      state.guestSeeAuth = data;
    },
    SET_REWARDCOUNT(state, data) {
      state.rewardCount = data;
    },
    SET_PRAISECOUNT(state, data) {
      state.praiseCount = data;
    },
    SET_THIRDPUSHSTREAMSTATUS(state, data) {
      state.thirdPushStreamStatus = data;
    },
    SET_AUTORECORDING(state, data) {
      state.autoRecording = data;
    },
    SET_AUDIT(state, data) {
      state.audit = data;
    },
    SET_OPTYPE(state, data) {
      state.opType = data;
    },
    SET_STREAMSTATUS(state, data) {
      state.streamStatus = data;
    },
    SET_USED(state, data) {
      state.used = data;
    },
    SET_TOPHIGHLIGHT(state, data) {
      state.tophighlight = data;
    },
    // pseudoLiveData
    SET_PSEUDOLIVE(state, data) {
      state.pseudoLiveInfo = data;
    },
    SET_USERNUMBER(state, data){
      state.userNumber = data
    },
    [SET_CUSTOMER_SERVICE](state, data){
      state.is_customer_service = data
    },
    SET_MEDIASTATUS(state, data){
      state.medaiStatus = data;
    },
    // 显示列表在线时长
    SET_USET_TIME(state, data) {
      state.hostUsersDuration = data;
    },
    SET_CHAT_IMAGE(state, data) {
      state.chatImages = data
    },
    SET_MIC_DEFAULT(state, data){
      state.micDefault = data;
    },
    SET_QA_ENABLED(state, data){
      state.qaEnabled = data
    },
    SET_RECORD_START_TIME(state, data){
      state.recordStartTime = data
    },
    SET_CAMERA_RESOLUTION(state,data){
      state.cameraResolution = data
    },
    SET_VIDEO_WALL(state,data){
      state.videoWall = data
    },
    SET_HOST_SKIN(state,data){
      state.hostSkin = data
    }
  },
};
export default liveInfo;
